var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      class: _vm.wrapClasses,
      style: _vm.wrapStyles,
      attrs: { tabindex: "0" },
      on: {
        click: _vm.toggle,
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          ) {
            return null
          }
          return _vm.toggle.apply(null, arguments)
        }
      }
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: _vm.name },
        domProps: { value: _vm.currentValue }
      }),
      _vm._v(" "),
      _c(
        "span",
        { class: _vm.innerClasses },
        [
          _vm.currentValue === _vm.trueValue ? _vm._t("open") : _vm._e(),
          _vm._v(" "),
          _vm.currentValue === _vm.falseValue ? _vm._t("close") : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fa88fc5", { render: render, staticRenderFns: staticRenderFns })
  }
}